import {Component, OnInit, ViewChild, AfterViewInit, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import * as moment from 'moment';
import { ColaboradorAutocompleteComponent } from '../common/autocomplete/colaborador-autocomplete/colaborador-autocomplete.component';
import { ComunicacionService, COM_DIALOG_STATE } from '../../services/comunicacion-service';
import { Observable } from 'rxjs/Observable';
import { PATH_COMUNICACION_DETAIL } from '../../navigation/navigation.module';
import { Router } from '@angular/router';
import { DialogsService } from '../../services/dialogs-service';
import { AuthenticationService } from '../../services/auth-service';
import { MdMenuTrigger } from '@angular/material';
import { SpinnerService } from '../../services/spinner-service';
import { ChipsSelectorComponent } from '../common/chips-selector/chips-selector.component';
import { PermisosService, PERM_ACCIONES_ID } from '../../services/permisos-service';
import { ActivatedRoute } from '@angular/router';
import {ActividadService, ACTIVITY_SCREEN_COMUNICACION} from '../../services/actividad-service';
import {NavigationService} from '../../services';

@Component({
  selector: 'app-comunicaciones',
  templateUrl: './comunicaciones.component.html',
  styleUrls: ['./comunicaciones.component.scss']
})
export class ComunicacionesComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('startDatePicker') startDatePicker;
  @ViewChild('endDatePicker') endDatePicker;
  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChild(MdMenuTrigger) triggerMenu: MdMenuTrigger;
  @ViewChildren(ChipsSelectorComponent) chipFilters: QueryList<ChipsSelectorComponent>;

  nuevoComunicadoAllowed = false;

  scrollSubscriber;

  showFilters = false;
  comunicaciones = [];
  comunicacionTipos = [];

  ColumnOrder = 'fecha';
  AscendingOrder = false;

  prioridadOptions = [
    {ID: 1, ItemLabel: 'Alta'},
    {ID: 2, ItemLabel: 'Media'},
    {ID: 3, ItemLabel: 'Baja'}];

  columnList = ['prior', 'titulo', 'autor', 'fecha', 'tipo'];

  filter = {
    FechaFrom: null,
    FechaTo: null,
    PageSize: 30,
    PageNumber: 0,
    AscendingOrder: this.AscendingOrder,
    ColumnOrder: 'fecha',
    UserId: Number(localStorage.getItem('userId')),
    FilterTipo: [],
    FilterPrioridad: [],
    FilterAutor: [],
    ConAdjunto : null,
    SearchString: '',
    Papelera: false,
    Propios: false
  };

  userID = '';

  // Fila elegida actualmente. -1 significa ninguno seleccionado
  public selectedRegister: number = -1;

  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  constructor(
    private comunicacionService: ComunicacionService,
    private router: Router,
    private dialogsService: DialogsService,
    private authService: AuthenticationService,
    private spinnerService: SpinnerService,
    private permisosService: PermisosService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private actividadService: ActividadService
  ) {
    permisosService.verificarAccesoDeURL();
    this.nuevoComunicadoAllowed = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_CrearComunicado);
  }

  ngOnInit() {
    this.comunicacionService.getComunicacionTipos()
      .subscribe( response => {
        this.comunicacionTipos = response;
        this.setChipFilterOptions('comTipo', response.map(x => ({ID: x.Id, ItemLabel: x.Tipo})));
      });
    this.userID = localStorage.getItem('userId');
    this.setChipFilterOptions('comPrioridad', this.prioridadOptions);
    this.getComunicaciones();
    this.actividadService.setActivityFlag(ACTIVITY_SCREEN_COMUNICACION, false);
    this.actividadService.updateComunicacionLastAccess().subscribe();
  }

  // Setear el Scroll infinito
  ngAfterViewInit() {
    const content = document.querySelector('.mat-drawer-content');
    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        const max = content.scrollHeight - content.clientHeight;
        if (x > max * 0.7) {
          this.onBottomReached();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  getComunicaciones(resetPage = true) {
    this.colaboradorAutocompleteComponent.selectedColaboradores.forEach(x => {
      this.filter.FilterAutor.push(x.UserId);
    });

    this.filter.ColumnOrder = this.ColumnOrder;
    this.filter.AscendingOrder = this.AscendingOrder;

    this.spinnerService.setShowFlag(true);
    this.comunicacionService.getComunicaciones(this.filter, resetPage)
      .subscribe(response => {
        if (response) {
          response.forEach(x => {
            x.Fecha = moment(x.Fecha).toDate();
          });
          if (resetPage) {
            this.comunicaciones = response;
          } else {
            this.comunicaciones = [...this.comunicaciones, ...response];
          }
          // cada vez que se busca, se llena el filtro de autor con los actuales, limpiarlos para evitar repetidos
          this.filter.FilterAutor = [];
        }
        this.spinnerService.setShowFlag(false);
      }, (err) => {
        this.spinnerService.setShowFlag(false);
      });
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  openFilters() {
    this.showFilters = true;
  }

  closeFilters() {
    this.showFilters = false;
  }

  onCleanFilters(e) {
    this.resetFilters();
    this.colaboradorAutocompleteComponent.selectedColaboradores = [];
    this.chipFilters.forEach(x => {
      x.unselectAllOptions();
    });
    this.closeFilters();
    this.getComunicaciones();
  }

  onApplyFilters() {
    if (this.filter.SearchString !== '') {
      const search = this.filter.SearchString;
      this.resetFilters();
      this.filter.SearchString = search.trim();
    }
    this.getComunicaciones();
  }

  showDatePicker(datePicker) {
    if (datePicker === 'start') {
      this.startDatePicker.open();
    }else if (datePicker === 'end') {
      this.endDatePicker.open();
    }
  }

  // Normalizar fechas: No seleccionar fechas futuras
  selectedStartDate(e) {
    const endOfDay = moment().endOf('day').toDate();
    const startOfDay = moment().startOf('day').toDate();

    if (this.filter.FechaTo === null) {
      this.filter.FechaTo = endOfDay;
    }

    if (e > endOfDay) {
      this.filter.FechaFrom = startOfDay;
    } else {
      this.filter.FechaFrom = e;
      // si se elige una fecha de inicio Mayor a fecha de fin, mover la fecha de fin
      if (this.filter.FechaTo < e) {
        this.filter.FechaTo = endOfDay;
      }
    }
  }

  selectedEndDate(e) {
    // verificar que no se pase de HOY
    const startOfDay = moment(e).startOf('day').toDate();
    const endOfDay = moment().endOf('day').toDate();

    if (this.filter.FechaTo === null) {
      this.filter.FechaFrom = startOfDay;
    }

    if (e > endOfDay) {
      this.filter.FechaTo = endOfDay;
    } else {
      this.filter.FechaTo = e;
      // si se elige una fecha de fin Menor a fecha de inicio, mover la fecha de inicio
      if (this.filter.FechaFrom > e) {
        this.filter.FechaFrom = startOfDay;
      }
    }
  }

  onBottomReached() {
    if (this.route.snapshot.params['page'] === ACTIVITY_SCREEN_COMUNICACION) {
      this.filter.PageNumber++;
      this.getComunicaciones(false);
    }
  }

  onSortChange(col) {
    if (col === this.ColumnOrder) {
      this.AscendingOrder = !this.AscendingOrder;
    } else {
      this.ColumnOrder = col;
      this.AscendingOrder = false;
    }
    this.getComunicaciones();
  }

  getColumnName(name) {
    name = name.charAt(0).toUpperCase() + name.slice(1);
    return name === 'Prior' ? name + '.' : name;
  }

  getColumnValue(name, row) {
    if (name === 'prior') {
      return this.comunicaciones[row].PrioridadComunicacionId;
    } else if (name === 'titulo') {
      return this.comunicaciones[row].Titulo;
    } else if (name === 'autor') {
      return this.comunicaciones[row].AutorNombre;
    } else if (name === 'fecha') {
      return this.comunicaciones[row].Fecha;
    } else if (name === 'tipo') {
      return this.comunicaciones[row].TipoComunicacion;
    }
  }

  // si se entrega parametro de comunicacion ir al mismo, si no ir al registro elegido si existe
  goToComunicacion(com = -1) {
    if (com !== -1) {
      this.router.navigate([PATH_COMUNICACION_DETAIL, com]);
    } else if (this.selectedRegister !== -1) {
      this.router.navigate([PATH_COMUNICACION_DETAIL, this.comunicaciones[this.selectedRegister].Id]);
    }
  }

  resetFilters() {
    this.filter = {
      FechaFrom: null,
      FechaTo: null,
      PageSize: 30,
      PageNumber: 0,
      AscendingOrder: this.AscendingOrder,
      ColumnOrder: 'fecha',
      UserId: Number(localStorage.getItem('userId')),
      FilterTipo: [],
      FilterPrioridad: [],
      FilterAutor: [],
      ConAdjunto : null,
      SearchString: '',
      Papelera: this.filter.Papelera,
      Propios: false
    };
  }

  public openNewComunicacionDialog() {
    this.dialogsService.showNewComunicacionDialog(null, COM_DIALOG_STATE.NEW)
      .subscribe( res => {
        if (res) {
          this.resetFilters();
          this.colaboradorAutocompleteComponent.selectedColaboradores = [];
          this.getComunicaciones();
        }
      });
  }

  selectRegister(index) {
    this.selectedRegister = index;
  }

  contextMenu(e, index) {
    e.preventDefault();

    this.selectRegister(index);

    this.triggerMenu.openMenu();

    setTimeout(_ => {
      const list = document.getElementsByClassName('negocios-context-menu');

      if (list) {
        const elem: any = list[0];
        elem.style.left = e.clientX + 'px';
        elem.parentElement.style.position = 'static';

        // Si hay espacio para desplegar el menú hacia abajo lo hacemos, sino lo desplegamos hacia arriba
        if (window.innerHeight - e.clientY >= elem.offsetHeight) {
          elem.style.top = e.clientY + 'px';
        } else {
          elem.style.top = e.clientY - elem.offsetHeight + 20 + 'px';
        }
      }
    }, 10);

    return false;
  }

  deleteComunicacion() {
    if (this.selectedRegister >= 0) {
      this.dialogsService.confirm('¿Está seguro de que desea Eliminar esta Comunicación?', null, 'Si, Eliminar', 'No, Cancelar')
        .subscribe(value => {

          if (!value){
            return;
          }

          this.comunicacionService.deleteComunicacion(this.comunicaciones[this.selectedRegister].Id)
            .subscribe(x => {
              if (x) {
                this.getComunicaciones();
              }
            });
        });
    }
  }

  cloneComunicacion() {
    if (this.selectedRegister >= 0) {
      const comunicacion = {Id: this.comunicaciones[this.selectedRegister].Id};
      this.dialogsService.showNewComunicacionDialog(comunicacion, COM_DIALOG_STATE.CLONE)
        .subscribe( res => {
          if (res) {
            this.resetFilters();
            this.colaboradorAutocompleteComponent.selectedColaboradores = [];
            this.getComunicaciones();
          }
        });
    }
  }

  userIsAutor() {
    if (this.selectedRegister !== -1) {
      return this.comunicaciones[this.selectedRegister].AutorId.toString() === localStorage.getItem('userId');
    } else {
      return false;
    }

  }

  setChipFilterOptions(filter: string, options) {
    setTimeout(() => {
      this.chipFilters.forEach(x => {
        if (x.Type === filter) {
          x.optionsChange(options);
        }
      });
    });
  }

  onChipsFilterChanged(e) {
    if (e.Type === 'comPrioridad') {
      this.filter.FilterPrioridad = e.SelectedIds;
    } else if (e.Type === 'comTipo') {
      this.filter.FilterTipo = e.SelectedIds;
    }
  }

  changeViewMode(e, view) {
    e.stopPropagation();
    if (view === 'activos' && this.filter.Papelera) {
      this.filter.Papelera = false;
      this.onApplyFilters();
    } else if (view === 'papelera' && !this.filter.Papelera) {
      this.filter.Papelera = true;
      this.onApplyFilters();
    }
  }

  onPropiosChange() {
    if (this.filter.Propios) {
      this.filter.FilterAutor = [];
      this.colaboradorAutocompleteComponent.selectedColaboradores = [];
    }
  }

  onAutocompleteChanged() {
    if (this.colaboradorAutocompleteComponent.selectedColaboradores.length && this.filter.Propios) {
      this.filter.Propios = false;
    }
  }

  permisoAutorizado(accionId) {
    return this.permisosService.permisoAutorizado(accionId);
  }

  toggleNav(){
    this.navigationService.toggleNav(true);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/comunicaciones.component.ts